import { render, staticRenderFns } from "./VChatMessages.vue?vue&type=template&id=295e5898&"
import script from "./VChatMessages.vue?vue&type=script&lang=ts&"
export * from "./VChatMessages.vue?vue&type=script&lang=ts&"
import style0 from "./VChatMessages.vue?vue&type=style&index=0&id=295e5898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports